import { render, staticRenderFns } from "./StringCategory.vue?vue&type=template&id=1f94d8e5&"
import script from "./StringCategory.vue?vue&type=script&lang=js&"
export * from "./StringCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports